import React, { useState, useEffect } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import { authProvider } from '../authProvider';


const NavMenu = (props) => {
    const [collapsed, setCollapsed] = useState(true);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isEstimator, setIsEstimator] = useState(false);
    const [isReader, setIsReader] = useState(false);
    const logout = () => {
        authProvider.logout();
    }
    const toggleNavbar = () => {
        setCollapsed(!collapsed);
    }
    useEffect(() => {
        authProvider.getIdToken().then((res) => {
            var roles = res.idToken.claims.roles;
            setIsAdmin(roles.includes("Administrator"));
            setIsEstimator(roles.includes("Estimate.ReadWrite"));
            setIsReader(roles.includes("Estimate.Read"));
        })
    }, []);
    return (<header>
        <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3 fixed-top" light>
            <Container fluid={true}>
                <NavbarBrand tag={Link} to="/"><img src="/Images/horizlogo.png" alt="Networking Technologies horizontal logo" /></NavbarBrand>
                <NavbarToggler onClick={toggleNavbar} className="mr-2" />
                <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!collapsed} navbar>
                    <ul className="navbar-nav flex-grow">
                        {isEstimator && <NavItem>
                            <NavLink tag={Link} className="text-dark" to="/Estimate">New Estimate</NavLink>
                        </NavItem>}
                        <NavItem>
                            <NavLink tag={Link} className="text-dark" to="/">Estimate List</NavLink>
                        </NavItem>
                        {isAdmin &&
                        <NavItem>
                            <NavLink tag={Link} className="text-dark" to="/admin/costing">Costing Defaults</NavLink>
                        </NavItem>}
                        {isAdmin && 
                        <NavItem>
                            <NavLink tag={Link} className="text-dark" to="/admin">Manage Access</NavLink>
                        </NavItem>}
                        <NavItem>
                            <NavLink tag={Link} className="text-dark" onClick={logout} to="#">Logout</NavLink>
                        </NavItem>
                    </ul>
                </Collapse>
            </Container>
        </Navbar>
    </header>);
}
export default NavMenu;
// export class NavMenu extends Component {
//     static displayName = NavMenu.name;

//     constructor(props) {
//         super(props);

//         this.toggleNavbar = this.toggleNavbar.bind(this);
//         this.state = {
//             collapsed: true
//         };
//     }
//     logout() {
//         authProvider.logout();
//     }
//     toggleNavbar() {
//         this.setState({
//             collapsed: !this.state.collapsed
//         });
//     }

//     render() {
//         return (
            
//         );
//     }
// }
